import React from "react";

import { Box, Stack, Typography } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

const OptionsDisplay = ({ options }) => {
  const { getMessage } = useLocalization();

  return (
    <>
      {Array.isArray(options) && options.length > 0 ? (
        <Stack>
          {options.map((option) => (
            <Box key={option.id || option._id}>
              <Typography sx={{ fontSize: "10px" }}>
                {option.name}
                {option.name_fr && ` / ${option.name_fr}`}
              </Typography>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography>{getMessage("notSet")}</Typography>
      )}
    </>
  );
};

export default OptionsDisplay;
